import React, {useEffect, useState} from 'react';
import MetaTags from 'react-meta-tags';  // Added Meta Tag npm Package
import { 
    Container, 
    Row, Col, Card, 
    CardBody, CardTitle, Table,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem, Modal, Alert, Input, Button, Badge} from "reactstrap";
    import { Link } from 'react-router-dom';

import Breadcrumbs from "../../components/Common/Breadcrumb";
import * as url from "../../helpers/url_helper"
import axios from 'axios';
import { formatDate, HRConfig, TOAST_OPTIONS } from './../../helpers/backend_helper';

import "flatpickr/dist/themes/material_blue.css";
import Flatpickr from "react-flatpickr";
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';

import toastr from "toastr";
import "toastr/build/toastr.min.css";

import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import PropTypes from "prop-types";

    const PDP = () => {
        const [dCases, setDCases] = useState([])
        const [modal, setmodal] = useState(false);
        const [modal_details, setmodal_details] = useState(false);
        const [isLoading, setIsLoading] = useState(false)
        const [empNo, setEmpNo] = useState('')
        const [empName, setEmpName] = useState('')
        const [empTitle, setEmpTitle] = useState('')
        const [postingDate, setPostingDate] = useState(new Date())
        const [skills, setSkills] = useState([])
        const [details, setDetails] = useState(null)

        toastr.options = TOAST_OPTIONS;

        const removeBodyCss = () => {
            document.body.classList.add("no_padding");
        }
        const tog_case = () => {
            setmodal(!modal);
            removeBodyCss();
        }
        const tog_details = () => {
            setmodal_details(!modal_details);
            removeBodyCss();
        }

        const [rows1, setrows1] = useState([{ id: 1 }]);

        const [formRows, setFormRows] = useState([{ id: 1 }]);

        const onAddFormRow = () => {
            const modifiedRows = [...formRows];
            modifiedRows.push({ id: modifiedRows.length + 1 });
            setFormRows(modifiedRows);
        };

        const onDeleteFormRow = id => {
            if (id !== 1) {
            var modifiedRows = [...formRows];
            modifiedRows = modifiedRows.filter(x => x["id"] !== id);
            setFormRows(modifiedRows);
            }
        };
        const handleClickDetails = (t) =>{
            setDetails(t)
            console.log(t)
            tog_details();
        }
        const handleCancelApproval = () =>{
            const data = {
                no: details.No
            }
            setIsLoading(true)
            axios.post(url.PDPCANCELAPPROVAL, data, HRConfig).then((r)=>{
                if(r.request.status == '204'){
                    toastr.success("Personal Development Plan Approval Cancelled")
                    tog_details()
                    getData()
                }else{
                    toastr.error("Could not Cancel")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })
        }
        const handleSubmit2Approve = () =>{
            const data = {
                no: details.No
            }
            setIsLoading(true)
            axios.post(url.PDPAPPROVAL, data, HRConfig).then((r)=>{
                if(r.request.status == '204'){
                    toastr.success("Personal Development Plan Sent For Approval")
                    tog_details()
                    getData()
                }else{
                    toastr.error("Could not Send Personal Development Plan For Approval")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })
        }
        const handleSubmit = () =>{
            const planLs = [];
            
            for(let i = 0; i < formRows.length; i++){
                const plan = {
                    DevtGoalsfortheyear:  document.getElementsByClassName('devtGoal')[i].value,
                    TrainingandDevtGoal:  document.getElementsByClassName('trainingDevtGoal')[i].value,
                    EmployeeActionSteps:  document.getElementsByClassName('actionStep')[i].value,
                    ResourcesNeeded:  document.getElementsByClassName('resourcesNeeded')[i].value,
                    StartDate:    formatDate(document.getElementsByClassName('lDates')[i]._flatpickr.selectedDates[0]) ,
                    EndDate:    formatDate(document.getElementsByClassName('lDates')[i]._flatpickr.selectedDates[1]) ,
                    SkillCode:  document.getElementsByClassName('skillToAcquire')[i].value,
                }
                planLs.push(plan);
            }
            const data = {
                EmployeeNo: empNo,
                PostingDate: formatDate(postingDate),
                personalDevtPlanLines:planLs
            }
           
            setIsLoading(true)
            axios.post(url.PDPEXPAND, data, HRConfig).then((r)=>{
                if(r.request.status == '201'){
                    toastr.success("Personal Development Plan Saved, You can submit for Approval")
                    tog_case()
                    getData()
                }else{
                    toastr.error("Could not Create Personal Development Plan")
                }
                setIsLoading(false)
            }).catch((e)=>{
                console.log(e)
                toastr.error(e.response.data.error.message)
                setIsLoading(false)
            })

        }

        const getData = () =>{
            setIsLoading(true)
            if (localStorage.getItem("authUser")) {
                const obj = JSON.parse(localStorage.getItem("authUser"));
                setEmpNo(obj.uid)
                setEmpName(obj.username)
                axios.get(`${url.EMPLOYEES}?$filter=No eq '${obj.uid}'`, HRConfig).then((r)=>{ setEmpTitle(r.data.value[0].JobTitle)}).catch((e)=>{ console.log(e)})
            }
            axios.get(url.PDPEXPAND, HRConfig).then((r)=>{ 
                setIsLoading(false)
                setDCases(r.data.value)
                //console.log(r.data.value)
            }).catch((e)=>{ console.log(e); setIsLoading(false); })
    
            axios.get(url.SKILLS, HRConfig).then((r)=>{ 
                setSkills(r.data.value)
            }).catch((e)=>{ console.log(e) })
        }
        useEffect(()=>{
           getData()
        },[])
        const { SearchBar } = Search;
        const columns = [
            {
              dataField: 'No',
              text: 'No',
              sort: true,
              formatter: noFormatter
            },
            {
              dataField: 'HRMDocumentType', 
              text: 'Type',
              sort: true
            }, 
            {
                dataField: 'EmployeeNo',
                isDummyField: true,
                text: 'Plan By',
                sort: true,
                formatter: raisedByFormatter
              }, 
              {
                dataField: 'PositionCode',
                isDummyField: true,
                text: 'Position',
                sort: true,
                formatter: positionFormatter
              }, 
            {
              dataField: 'PostingDate',
              text: 'Date Posted',
              sort: true
            }, 
            {
                dataField: 'personalDevtPlanLines',
                isDummyField: true,
                text: 'Plans',
                sort: true,
                formatter: planFormatter
              },
            {
              dataField: 'Status',
              text: 'Status',
              sort: true,
              formatter: statusFormatter
            },
            {
              dataField: "action",
              isDummyField: true,
              text: "",
              formatter: actionFormatter
            }];
      
            const defaultSorted = [{
              dataField: 'No',
              order: 'desc'
            }];
      
            function planFormatter(cellContent,row){
              return(
                <span> <strong>{row.personalDevtPlanLines.length}</strong></span>
              )
            }
            function raisedByFormatter(cellContent,row){
                return(
                  <span> {row.EmployeeName}<br/>{row.EmployeeNo}</span>
                )
              }
            function positionFormatter(cellContent, row){
              return(
                <span> {row.PositionName}<br/>{row.PositionCode}</span>
              )
            }
            function noFormatter(cellContent, row){
              return(
                <strong>{cellContent}</strong>
              )
            }
      
            function actionFormatter(cellContent, row){
              return(
                <>
                <div className="d-flex gap-3">
                <UncontrolledDropdown direction="left">
                    <DropdownToggle href="#" className="card-drop" tag="i">
                      <i className="mdi mdi-dots-horizontal font-size-18" />
                    </DropdownToggle>
                    <DropdownMenu className="dropdown-menu-end">
                 
                      <DropdownItem
                        onClick={() => { handleClickDetails(row); }}
                      >
                        <i className="fas fa-address-card text-warning me-1" />
                        View Personal Development Plan Details
                      </DropdownItem>
                     
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </div>
              </>
              )
            }
            function statusFormatter(cellContent, row) {
              if (row.Status == "Open") {
                return (
                  <div>
                      <Badge className="me-2 bg-danger">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Approved"){
                return (
                  <div>
                      <Badge className="me-2 bg-success">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else if (row.Status == "Withdrawn(Cancelled)"){
                return (
                  <div>
                      <Badge className="me-2 bg-secondary">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }else{
                return (
                  <div>
                      <Badge className="me-2 bg-warning">
                      { cellContent }
                      </Badge>
                  </div>
                );
              }
            }
        
        return (
            <>
                <div className="page-content">
                    <MetaTags>
                    <title>Personal Development Plan | BRIDGE</title>
                    </MetaTags>
                    <Container fluid={true}>
                        <Breadcrumbs title="Human Resource Management" breadcrumbItem="Personal Development Plan" />
                        <Row>
                        <Col lg={12}>
                                {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                            </Col>
                        <Col xl={12}>
                            <Card>
                                <CardBody>
                                
                                <Modal
                                  isOpen={modal}
                                  toggle={() => { tog_case()  }}
                                  size="xl"
                                  centered
                                  backdrop={'static'}
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Create Personal Development Plan` }</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                    <Col lg={12}>
                                        {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                                    </Col>
                                    <Col sm={12} className="mb-3">
                                        <Row>
                                        <Col md={3}>
                                            <div className="form-floating mb-1">
                                            <input name='EmployeeNo' id="EmployeeNo" type="text" className="form-control" disabled={true}  defaultValue = {empNo} />
                                            <label htmlFor="floatingIdInput">Employee No</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-1">
                                            <input name='EmployeeName' id="EmployeeName"  type="text" className="form-control" disabled={true} defaultValue={empName} />
                                            <label htmlFor="floatingnameInput">Employee Name</label>
                                            </div>
                                        </Col>
                                      
                                
                                        <Col md={3}>
                                            <div className="form-floating mb-1">
                                            <input name='Title' id="Title"  type="text" className="form-control" disabled={true} defaultValue={empTitle} />
                                            <label htmlFor="floatingDepartInput">Title</label>
                                            </div>
                                        </Col>
                                        <Col md={3}>
                                            <div className="form-floating mb-1">
                                            <Flatpickr
                                                className="form-control"
                                                placeholder="dd M,yyyy"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    defaultDate: new Date()
                                                }}
                                                onChange={(d)=>{setPostingDate(d)}}
                                                />
                                            <label htmlFor="floatingDepartInput">Posting Date</label>
                                            </div>
                                        </Col>
                                        </Row>
                                    </Col>
                                    <Col  xl={12}>
                       
                                
                       <div>
                               {(formRows || []).map((formRow, key) => (
                           <span key={key}>
        
                           <strong className='mb-2'>Development Plan Line {formRow.id}</strong> 
                                   <Row >
                                   
                               
               
                                   <Col lg={3} className="mb-3">
                                   <div className="form-floating mb-3">
                                       <input type="text" className='form-control devtGoal' /> 
                                       <label htmlFor="floatingSelectGrid">Development Goal for the Year</label>
                                   </div>
                                   </Col>
                                   <Col lg={3} className="mb-3">
                                   <div className="form-floating mb-3">
                                       <input type="text" className='form-control trainingDevtGoal' />
                                       <label htmlFor="floatingSelectGrid">Training and Development Goal</label>
                                   </div>
                                   </Col>
                                   <Col lg={3} className="mb-3">
                                   <div className="form-floating ">
                                       <select className='form-select skillToAcquire'>{skills.map((s,k)=>(<option key={k} value={s.Code}>{s.Description}</option>))}</select>
                                       <label htmlFor="floatingSelectGrid">Skill to be Acquired</label>
                                   </div>
                                   </Col>
                                   
                                   <Col lg={3} className="mb-3">
                                   <div className="form-floating">
                                       <input type="text" className='form-control actionStep' />
                                       <label htmlFor="floatingSelectGrid">Employee Action Step</label>
                                   </div>
                                   </Col>
                                   <Col lg={3} className="mb-3">
                                   <div className="form-floating">
                                       <input type="text" className='form-control resourcesNeeded' />
                                       <label htmlFor="floatingSelectGrid">Resources Needed</label>
                                   </div>
                                   </Col>

                                   <Col lg={3} className="mb-3">
                                       <div className="form-floating mb-3">
                                       <Flatpickr
                                           className="form-control lDates"
                                           placeholder="dd M,yyyy"
                                           options={{
                                               mode: "range",
                                               dateFormat: "Y-m-d"
                                           }}
                                           />
                                       <label htmlFor="floatingPlanningDateInput">Start Date - End Date</label>
                                       </div>
                                   </Col>
                                   <Col lg={1} className="align-self-center">
                                       <div className="form-floating mb-3">
                                       
                                       <input
                                           type="button"
                                           className="btn btn-primary"
                                           value="Remove"
                                           onClick={() => onDeleteFormRow(formRow.id)}
                                       />
                                       </div>
                                   </Col>
                                   </Row>
                                  </span>
                               ))}
                               <Row>
                                   <Col md={6}>
                                   <div className="d-grid gap-2">
                                       <input
                                           type="button"
                                           className="btn btn-success mt-3 mt-lg-0"
                                           value="Add Development Plan Line"
                                           onClick={() => onAddFormRow()}
                                       />
                                   </div>
                                   </Col>
                                   <Col md={6}>
                                       <div className="d-grid gap-2">
                                           <Button color="primary" type="button" className="btn" onClick={handleSubmit} >
                                               Submit Personal Development Plan
                                           </Button>
                                       </div>
                                   </Col>
                                   </Row>
                                   </div>
                                  
                                   
             
                                   
           
                                </Col>
                                  </Row>  
                                 
                                   
                                  </div>
                                 
                                </Modal>


                                <Modal
                                  isOpen={modal_details}
                                  toggle={() => { tog_details()  }}
                                  size="xl"
                                  centered
                                  backdrop={'static'}
                                >
                                  <div className="modal-header">
                                    <h5 className="modal-title mt-0" id="myModalLabel">{ `Personal Development Plan` }</h5>
                                    <button
                                      type="button"
                                      onClick={() => {
                                        setmodal_details(false);
                                      }}
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                    >
                                      <span aria-hidden="true">&times;</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                  <Row>
                                  <Col lg={12}>
                                    {isLoading ? (<Alert  color="danger" role="alert">Please wait...</Alert>) : null}
                                  </Col>
                          
                                    {details && (
                                        <>
                                    
                                        <Col md={4}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeNo' id="EmployeeNo" type="text" className="form-control" disabled={true}  defaultValue = {details.No +"/ "+ details.Status } />
                                            <label htmlFor="floatingIdInput">No/Status</label>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeNo' id="EmployeeNo" type="text" className="form-control" disabled={true}  defaultValue = {details.EmployeeNo} />
                                            <label htmlFor="floatingIdInput">Employee No</label>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-floating mb-3">
                                            <input name='EmployeeName' id="EmployeeName"  type="text" className="form-control" disabled={true} defaultValue={details.EmployeeName} />
                                            <label htmlFor="floatingnameInput">Employee Name</label>
                                            </div>
                                        </Col>
                                      
                                
                                        <Col md={4}>
                                            <div className="form-floating mb-3">
                                            <input name='Title' id="Title"  type="text" className="form-control" disabled={true} defaultValue={details.PositionName} />
                                            <label htmlFor="floatingDepartInput">Title</label>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-floating mb-1">
                                            <input name='EmployeeName' id="EmployeeName"  type="text" className="form-control" disabled={true} defaultValue={details.HRMDocumentType} />
                                            <label htmlFor="floatingnameInput">Document Name</label>
                                            </div>
                                        </Col>
                                        <Col md={4}>
                                            <div className="form-floating mb-1">
                                            <Flatpickr
                                                className="form-control"
                                                placeholder="dd M,yyyy"
                                                options={{
                                                    dateFormat: "Y-m-d",
                                                    defaultDate: new Date(details.PostingDate) 
                                                }}
                                                onChange={(d)=>{setPostingDate(d)}}
                                                />
                                            <label htmlFor="floatingDepartInput">Posting Date</label>
                                            </div>
                                        </Col>
                                        <Col  xl={12}>
                       
                                
                       <div>
                               {(details.personalDevtPlanLines).map((formRow, key) => (
                           <span key={key}>
        
                           <strong className='mb-2'>Development Plan Line {key+1}</strong> 
                                   <Row >
                                   
                               
               
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating mb-3">
                                       <input type="text" className='form-control devtGoal' defaultValue={formRow.DevtGoalsfortheyear} /> 
                                       <label htmlFor="floatingSelectGrid">Development Goal for the Year</label>
                                   </div>
                                   </Col>
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating mb-3">
                                       <input type="text" className='form-control trainingDevtGoal' defaultValue={formRow.TrainingandDevtGoal} />
                                       <label htmlFor="floatingSelectGrid">Training and Development Goal</label>
                                   </div>
                                   </Col>
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating ">
                                       <select className='form-select skillToAcquire' defaultValue={formRow.SkillCode}  >{skills.map((s,k)=>(<option key={k} value={s.Code}>{s.Description}</option>))}</select>
                                       <label htmlFor="floatingSelectGrid">Skill to be Acquired</label>
                                   </div>
                                   </Col>
                                   
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating">
                                       <input type="text" className='form-control actionStep' defaultValue={formRow.EmployeeActionSteps} />
                                       <label htmlFor="floatingSelectGrid">Employee Action Step</label>
                                   </div>
                                   </Col>
                                   <Col lg={4} className="mb-3">
                                   <div className="form-floating">
                                       <input type="text" className='form-control resourcesNeeded' defaultValue={formRow.ResourcesNeeded} />
                                       <label htmlFor="floatingSelectGrid">Resources Needed</label>
                                   </div>
                                   </Col>

                                   <Col lg={4} className="mb-3">
                                       <div className="form-floating mb-3">
                                       <Flatpickr
                                           className="form-control lDates"
                                           placeholder="dd M,yyyy"
                                           options={{
                                               mode: "range",
                                               dateFormat: "Y-m-d",
                                               defaultDate: [new Date(formRow.StartDate), new Date(formRow.EndDate)] 
                                           }}
                                           />
                                       <label htmlFor="floatingPlanningDateInput">Start Date - End Date</label>
                                       </div>
                                   </Col>
                                   
                                   </Row>
                                  </span>
                               ))}
                               <Row>
                       
                                   <Col md={12}>
                                   {(details.Status == "Open") && (
                                       <div className="d-grid gap-2">
                                           <Button color="warning" type="button" className="btn" onClick={handleSubmit2Approve} >
                                               Send Approval Request
                                           </Button>
                                       </div>
                                    )}
                                    {(details.Status == "Pending Approval") && (
                                        <div className="d-grid gap-2">
                                           <Button color="danger" type="button" className="btn" onClick={handleCancelApproval} >
                                               Cancel Approval Request
                                           </Button>
                                       </div>
                                    )}
                                   </Col>
                                   </Row>
                                   </div>
     
                                </Col>
                                        </>
                                    )}
                                    
                                  </Row>  
                                 
                                   
                                  </div>
                                  
                                </Modal>

                  
                               {(dCases.length > 0) && (<>

                                    <ToolkitProvider
                                        keyField="No"
                                        data={ dCases }
                                        columns={ columns }
                                        search
                                        >
                                        { toolkitProps => (
                                            <React.Fragment>
                                                <Row className='mb-5'>
                                                  <Col lg={10}>
                                                  <div  className="rounded bg-light d-grid gap-2">
                                           
                                                      <SearchBar {...toolkitProps.searchProps} className="form-control bg-transparent border-0 searchTm m-0" />
                                                 
                                                    </div>
                                                  </Col>
                                            
                                                  <Col lg={2}> 
                                                  <div className="d-grid gap-2">
                                                    <Link
                                                      className="btn btn-primary"
                                                      to="#"
                                                      onClick={()=>{tog_case()}}
                                                    >
                                                      <i className="mdi mdi-plus me-1" />
                                                      Create PDP
                                                    </Link>
                                                  </div>
                                                  </Col>
                                                </Row>
                                                <Row>
                                                <Col xl="12">
                                                    <div className="table">
                                                
                                                    <BootstrapTable 
                                                    keyField='No' 
                                                    data={ dCases } 
                                                    columns={ columns } 
                                                    striped
                                                    hover
                                                    condensed
                                                    bordered={ false }
                                                    noDataIndication="No Records" 
                                                    defaultSorted={ defaultSorted }
                                                    classes={ "table align-middle table-nowrap table-check" }
                                                        {...toolkitProps.baseProps}
                                                    />
                                                </div>
                                                </Col>
                                                </Row>
                                                </React.Fragment>
                                                
                                        )
                                        }
                                    </ToolkitProvider>
                  

                              
                                </>)}
                                {(dCases.length < 1) && (<>
                                    <Row className="d-flex justify-content-center">
                                <Col lg={8} >
                                
                                    
                                    <div className="text-center">
                                        <div className="mb-4">
                                        <i className="mdi mdi-check-circle-outline text-success display-4" />
                                        </div>
                                        <div>
                                        <h5>All Done</h5>
                                        <p className="text-muted">
                                                No PDPs found
                                        </p>
                                        </div>
                                    </div>
                              
                                </Col>
                            </Row>
                                </>)}
                                </CardBody>
                            </Card>
                            </Col>
                        </Row>
                           

                    </Container>
                </div>
            </>
        );
    }

export default PDP;